import { render, staticRenderFns } from "./BrilliantAudience.vue?vue&type=template&id=46a6e88c&scoped=true&"
import script from "./BrilliantAudience.vue?vue&type=script&lang=ts&"
export * from "./BrilliantAudience.vue?vue&type=script&lang=ts&"
import style0 from "./BrilliantAudience.vue?vue&type=style&index=0&id=46a6e88c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a6e88c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('46a6e88c', component.options)
    } else {
      api.reload('46a6e88c', component.options)
    }
    module.hot.accept("./BrilliantAudience.vue?vue&type=template&id=46a6e88c&scoped=true&", function () {
      api.rerender('46a6e88c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/components/BrilliantAudience.vue"
export default component.exports